import angular from 'angular';
import chargecodesComponent from './chargecodes.component';

let chargecodesModule = angular.module('chargecodes', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('chargecodes', chargecodesComponent);

export default chargecodesModule;



// WEBPACK FOOTER //
// ./client/pages/admin/chargecodes/chargecodes.js